export enum CompensationEditMode {
  None,
  User,
  Manager,
  Admin,
}
